module.exports = __webpack_public_path__ + "static/media/auditoriumM.bb9ec6bf.png";